import Vue from 'vue'
import VueRouter from 'vue-router'

// Amplify関連
import { AmplifyEventBus, AmplifyPlugin } from 'aws-amplify-vue'
import Amplify, * as AmplifyModules from 'aws-amplify'

// Main Page
import MainPage from '../components/admin/MainPage.vue'
// main objects
import SystemSpecification from '../components/admin/objects/SystemSpecification.vue'
import SystemFunction from '../components/admin/objects/SystemFunction.vue'
import Usecase from '../components/admin/objects/Usecase.vue'
import CommunicationDesign from '../components/admin/objects/CommunicationDesign.vue'
import Property from '../components/admin/objects/Property.vue'
// import Attribute from '../components/admin/objects/Attribute.vue'
import NotFoundError from '../components/errors/NotFoundError.vue'

// progress
import PropertyProgress from '../components/admin/progress/Property.vue'
import AttributeProgress from '../components/admin/progress/Attribute.vue'
import CommandProgress from '../components/admin/progress/Command.vue'

// difinitoins
import FunctionClassDifinition from '../components/admin/difinition/FunctionClass.vue'
import FrameTypeDifinition from '../components/admin/difinition/FrameType.vue'
import CommunicationTriggerDifinition from '../components/admin/difinition/CommunicationTrigger.vue'
import CommunicationPathDifinition from '../components/admin/difinition/CommunicationPath.vue'

// list
import PropertyList from '../components/admin/list/Properties.vue'
import AttributeList from '../components/admin/list/Attributes.vue'
import CommandList from '../components/admin/list/Commands.vue'

// Authenticator
import Authenticator from '../components/auth/Authenticator.vue'

Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)

let user

getUser()

AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    user = null
    router.push({ path: '/auth' })
  } else if (state === 'signedIn') {
    user = await getUser()
    router.push({ path: '/' })
  }
})

function getUser () {
  return Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      return data
    }
  }).catch((e) => {
    return null
  })
}

const routes = [
  // main objects
  {
    path: '/',
    name: 'root',
    component: MainPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/system_specification/:systemSpecificationId*',
    name: 'systemSpecification',
    component: SystemSpecification,
    meta: { requiresAuth: true }
  },
  {
    path: '/system_function/:systemFunctionId*',
    name: 'systemFunction',
    component: SystemFunction,
    meta: { requiresAuth: true }
  },
  {
    path: '/usecase/:usecaseId*',
    name: 'usecase',
    component: Usecase,
    meta: { requiresAuth: true }
  },
  {
    path: '/communication_design/:communicationDesignId*',
    name: 'communicationDesign',
    component: CommunicationDesign,
    meta: { requiresAuth: true }
  },
  {
    path: '/property/:propertyId*',
    name: 'Property',
    component: Property,
    meta: { requiresAuth: true }
  },
  {
    path: '/progress/property',
    name: 'PropertyProgress',
    component: PropertyProgress,
    meta: { requiresAuth: true }
  },
  {
    path: '/progress/attribute',
    name: 'AttributeProgress',
    component: AttributeProgress,
    meta: { requiresAuth: true }
  },
  {
    path: '/progress/command',
    name: 'CommandProgress',
    component: CommandProgress,
    meta: { requiresAuth: true }
  },
  // difinition pages
  {
    path: '/difinition/function_class',
    name: 'FunctionClassDifinition',
    component: FunctionClassDifinition,
    meta: { requiresAuth: true }
  },
  {
    path: '/difinition/frame_type',
    name: 'FrameTypeDifinition',
    component: FrameTypeDifinition,
    meta: { requiresAuth: true }
  },
  {
    path: '/difinition/communication_trigger',
    name: 'CommunicationTriggerDifinition',
    component: CommunicationTriggerDifinition,
    meta: { requiresAuth: true }
  },
  {
    path: '/difinition/communication_path',
    name: 'CommunicationPathDifinition',
    component: CommunicationPathDifinition,
    meta: { requiresAuth: true }
  },
  // list pages
  {
    path: '/list/properties',
    name: 'PropertyList',
    component: PropertyList,
    meta: { requiresAuth: true }
  },
  {
    path: '/list/attributes',
    name: 'AttributeList',
    component: AttributeList,
    meta: { requiresAuth: true }
  },
  {
    path: '/list/commands',
    name: 'CommandList',
    component: CommandList,
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'Authenticator',
    component: Authenticator
  },
  // not exist page
  {
    path: '/*',
    name: 'NotFoundError',
    component: NotFoundError
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser()
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      })
    }
    return next()
  }
  return next()
})

export default router
